import * as React from 'react';

export const lockedBig = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="62"
    height="78"
    viewBox="0 0 62 78"
    fill="none"
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.7722 77.3737H14.2559C6.3973 77.3737 0 71.0238 0 63.2189V42.3096C0 36.2081 3.85616 30.9049 9.54039 28.9422V18.9134C9.54039 8.48538 18.0843 -0.00012207 28.5841 -0.00012207H32.444C42.9456 -0.00012207 51.4896 8.48538 51.4896 18.9134V28.944C57.1738 30.9049 61.0281 36.2081 61.0281 42.3096V63.2189C61.0281 71.0238 54.6327 77.3737 46.7722 77.3737ZM41.1141 30.6345H20.0029C18.884 30.6345 17.9758 29.8456 17.9758 28.8697V18.1621C17.9758 13.1439 22.664 9.06243 28.4261 9.06243H32.6888C38.4509 9.06243 43.1432 13.1439 43.1432 18.1621V28.8697C43.1432 29.8456 42.2329 30.6345 41.1141 30.6345ZM25.1665 54.6687C25.1665 57.2761 27.5856 59.3971 30.5595 59.3971C33.5333 59.3971 35.9525 57.2761 35.9525 54.6687V49.7426C35.9525 47.1352 33.5333 45.0158 30.5595 45.0158C27.5856 45.0158 25.1665 47.1352 25.1665 49.7426V54.6687Z"
      />
    </g>
  </svg>
);
